module.exports = function() {
  return new Worker(__webpack_public_path__ + "f15f7cb7caa6deeb49e4.worker.js");
};